import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import { getDatesRange, dateFormater } from '../utils';
import dict from '../../dictionary';

const latestDate = Object.values(ReducedData.statusOfCasesPhu)
  .reverse()[0]
  .FILE_DATE.toString();

const formattedDate = [
  latestDate.slice(0, 4),
  latestDate.slice(4, 6),
  latestDate.slice(6, 8),
].join('-');

const phuData = Object.values(ReducedData.statusOfCasesPhu);
let phuNum = {};
const phus = Object.keys(ReducedData.dataPHU);

class PHUStatusTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  setData = () => {
    ReducedData.dataTesting.forEach((item) => {
      if (!Object.keys(phuNum).includes(item.PHU_num)) {
        for (var key in dict.PHUs) {
          if (dict.PHUs[key] === item.PHU_name) {
            phuNum[item.PHU_num] = key;
          }
        }
      }
    });
    phuNum[2268] = 'Windsor-Essex County Health Unit';

    var data;

    const compare = (a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    };

    switch (this.props.selectedTab) {
      case 'newCases': {
        data = phus
          .map((phuName, i) => {
            return phuData.reduce((sum, item) => {
              if (phuNum[item.PHU_NUM] !== phuName) return sum;
              const date = item.FILE_DATE.toString();
              const goodDate =
                [
                  date.slice(0, 4),
                  date.slice(4, 6),
                  date.slice(6, 8),
                ].join('-') + 'T00:00:00';
              sum[goodDate] = item[this.props.field];
              sum['name'] = phuNum[item.PHU_NUM];
              return sum;
            }, {});
          })
          .sort(compare);
        break;
      }
      case 'totalCases': {
        data = phus
          .map((phuName) => {
            let prevDate;
            let i = 0;
            return phuData.reduce((sum, item) => {
              if (phuNum[item.PHU_NUM] !== phuName) return sum;
              const date = item.FILE_DATE.toString();
              const goodDate =
                [
                  date.slice(0, 4),
                  date.slice(4, 6),
                  date.slice(6, 8),
                ].join('-') + 'T00:00:00';
              if (i === 0) {
                sum[goodDate] = item[this.props.field];
                prevDate = goodDate;
                i++;
              } else {
                sum[goodDate] =
                  item[this.props.field] + sum[prevDate];
                prevDate = goodDate;
              }
              sum['name'] = phuNum[item.PHU_NUM];
              return sum;
            }, {});
          })
          .sort(compare);
        break;
      }
      default:
        break;
    }
    //columns are days

    var dates = getDatesRange('2020-04-01', formattedDate);
    dates.reverse().unshift('Public Health Unit');
    var columns = dates.map((item, z) => {
      return {
        title: z === 0 ? item : dateFormater(item),
        dataIndex: z === 0 ? 'name' : item + 'T00:00:00',
        key: item.toLocaleString,
        width: z === 0 ? '10%' : '1%',
      };
    });

    this.setState({ data, columns });
  };

  componentDidMount() {
    this.setData();
  }

  render() {
    return (
      <Table
        bordered
        columns={this.state.columns}
        dataSource={this.state.data}
        scroll={{ x: true }}
        pagination={{ pageSize: 4 }}
      />
    );
  }
}

export default PHUStatusTable;
